import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=5fd4e936"
import script from "./GenericTable.vue?vue&type=script&lang=ts"
export * from "./GenericTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports